/** Uma folha do menu: o que a busca da navbar sabe abrir. */
export interface Tool {
    title: string;
    link: string;
    externalLink?: string;
    aitrusRedirect?: string;
    /** Item-pai, quando a ferramenta vem de um submenu — desempata títulos parecidos. */
    section?: string;
}

/**
 * O que distingue uma ferramenta de outra. Não dá para usar só o `link`: todo item
 * Aitrus tem link vazio, então dois deles pareceriam a mesma ferramenta e um comeria
 * o outro no histórico e na lista de resultados.
 */
export function chaveTool(t: Tool): string {
    return t.aitrusRedirect ? `aitrus:${t.aitrusRedirect}` : (t.externalLink || t.link);
}
